import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';

import { scripts } from '../constants';

const Layout = () => {
    const loadScripts = () => {
        scripts.map((ele)=>{
            const script = document.createElement('script')
            script.src = ele;
            script.async = true;
        
            document.body.appendChild(script);
        })
    }

    React.useEffect(() => {
        loadScripts();
    }, [])
    return (
        <div className="uppercase-text">
            <main>
                <div className="preloader-wrap" data-firstline="Stay" data-secondline="Relaxed">
                    <div className="outer">
                        <div className="inner">                    
                            <div className="trackbar">
                                <ul className="preloader-intro">
                                    <li className="preloader-list">Stake</li>
                                    <li className="preloader-list">Earn</li>
                                    <li className="preloader-list">Grow</li>
                                    <li className="preloader-list">Stake</li>
                                    <li className="preloader-list">Earn</li>
                                    <li className="preloader-list">Grow</li>
                                    <li className="preloader-list">Stake</li>
                                    <li className="preloader-list">Earn</li>
                                    <li className="preloader-list">Grow</li>
                                </ul>
                                <div className="loadbar"></div>
                            </div>
                            <div className="percentage-wrapper">
                                <div className="percentage" id="precent"></div>
                            </div>
                            <div className="percentage-intro">Please Wait</div>                     
                        </div>
                    </div>
                </div>
                <div className="cd-index cd-main-content">
                    <div id="page-content" className="dark-content" data-bgcolor="#eee">
                        <Header />
                        <div id="content-scroll">
                            <Outlet />
                            <Footer />
                        </div>
                        <div id="app"></div>
                    </div>    
                </div>
            </main>
            <div className="cd-cover-layer"></div>
            <div id="magic-cursor">
                <div id="ball">
                    <div id="ball-drag-x"></div>
                    <div id="ball-drag-y"></div>
                    <div id="ball-loader"></div>
                </div>
            </div>
            <div id="clone-image">
                <div className="hero-translate"></div>
            </div>
            <div id="rotate-device"></div>
        </div>
    )
}

export default Layout;